import store from './store';

export default function setGlobals(app) {

    ///////////////////////////////////////////////////////////////////////////
    // Pay for my Trip Configuration Variables
    //
    // These should be identical regardless of environment, otherwise use .env
    ///////////////////////////////////////////////////////////////////////////


    ////////////////////////////////////////
    // Pay for my Trip Helper Functions
    ////////////////////////////////////////
    app.config.globalProperties.$config = {
        urls: {
            //P4MT Wordpress paths.
            about: 'https://www.payformytrip.com/about/',
            terms: 'https://www.payformytrip.com/terms-and-conditions/',
            privacy: 'https://www.payformytrip.com/privacy-policy/',

            //Trustmark logo links.
            arc: 'https://www2.arccorp.com/',
            iata: 'https://www.iata.org/',
            worldpay: 'https://www.fisglobal.com/en/merchant-solutions-worldpay',
            cybersource: 'https://www.cybersource.com/'
        }
    }


    //this is a locally scoped helper function, used in several $filters below.
    let convertDateTimeToISO8601 = function(rawDateTime) {
        //Check for presence of a colon.
        if (rawDateTime.includes(':')) {
            return rawDateTime.replace(' ', 'T') + 'Z'; //Convert MySQL style date time to ISO-8601 datetime string.
        }
        return rawDateTime; //MySQL date (no time) format already matches ISO-8601 date format.
    };

    //Convert from the 2 character locale stored in our store, to the more verbose locale required for datetime operations.
    let getDateTimeLocale = function(storeLocale) {
        switch(storeLocale) {
            case 'es':
                return 'es-MX'; //Spanish - Mexico
            case 'en':
            default:
                return 'en-US'; //English - United States
        }
    }

    //Vue 3 removed filters. This is the official workaround suggested helper functions to format display data.
    //https://v3.vuejs.org/guide/migration/filters.html#global-filters
    app.config.globalProperties.$filters = {

        //THE FOLLOWING FUNCTION REQUIRES THAT rawDate IS IN AN ISO 8601 FORMAT
        //otherwise it will parse with local time, and be incorrect as we are forcing UTC timezone in
        //the subsequent call to toLocaleDateString.
        beautifyDate(rawDate) {
            if (rawDate === null) return null;

            //TODO parsing date strings directly is discouraged.
            //See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date
            let date = new Date(convertDateTimeToISO8601(rawDate));

            return date.toLocaleDateString(getDateTimeLocale(store.state.locale), {
                weekday: 'short',
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                timeZone: 'UTC' //Date as parsed above should be in UTC if rawDate was ISO 8601 compliant.
            });
        },

        //THE FOLLOWING FUNCTION REQUIRES THAT rawDate IS IN AN ISO 8601 FORMAT
        //otherwise it will parse with local time, and be incorrect as we are forcing UTC timezone in
        //the subsequent call to toLocaleDateString.
        beautifyDateTime(rawDateTime) {
            if (rawDateTime === null) return null;

            //TODO parsing date strings directly is discouraged.
            //See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date

            let date = new Date(convertDateTimeToISO8601(rawDateTime));

            return date.toLocaleString(getDateTimeLocale(store.state.locale), {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hourCycle: 'h12',
                timeZone: 'UTC' //Date as parsed above should be in UTC if rawDate was ISO 8601 compliant.
            });
        },

        //THE FOLLOWING FUNCTION REQUIRES THAT rawDate IS IN AN ISO 8601 FORMAT
        //otherwise it will parse with local time, and be incorrect as we are forcing UTC timezone in
        //the subsequent call to toLocaleDateString.
        beautifyTime(rawDateTime) {
            if (rawDateTime === null) return null;

            //TODO parsing date strings directly is discouraged.
            //See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date
            let date = new Date(convertDateTimeToISO8601(rawDateTime));

            return date.toLocaleString(getDateTimeLocale(store.state.locale), {
                hour: 'numeric',
                minute: '2-digit',
                hourCycle: 'h12',
                timeZone: 'UTC' //Date as parsed above should be in UTC if rawDate was ISO 8601 compliant.
            });
        },
        beautifyCurrency(amount) {
            return new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: 'USD'
            }).format(amount);
        }
    };
}
